import { Factory } from "../../core/factory";

import { DEFAULT_ANIMATION_CONFIG } from "../../animation/config";

export const treemapPresetAnimation = preset => "fadeIn" === preset ? {
    type: "fadeIn"
} : {
    type: "growCenterIn"
};

export const registerTreemapAnimation = () => {
    Factory.registerAnimation("treemap", ((params, preset) => ({
        appear: treemapPresetAnimation(preset),
        enter: {
            type: "growCenterIn"
        },
        exit: {
            type: "growCenterOut"
        },
        disappear: {
            duration: DEFAULT_ANIMATION_CONFIG.disappear.duration
        }
    })));
};
//# sourceMappingURL=animation.js.map
